<div class="flex items-center justify-center p-4 pt-20">
  <edu-error
    [header]="'shared.pages.url-not-found.title' | transloco"
    [description]="'shared.pages.url-not-found.description' | transloco"
  />
</div>
